<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="type" value-field="value"
                            display-field="${item.key}"
                            type="select2" :label="false" :items="types"
                            :options="{placeholder: $t('Type')}"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="no" :placeholder="$t('No')" :label="false"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="status" value-field="value" display-field="${item.key}"
                            type="select2" :label="false" :items="statuses" :options="{placeholder: $t('Status')}"/>
            </div>
            <div class="input-wrapper">
              <item-location-select-input-widget :model="searchModel" attribute="origin_item_location_uuid"
                                                 :label="false"
                                                 :placeholder="$t('Origin Item Location')"/>
            </div>
            <div class="input-wrapper">
              <item-location-select-input-widget :model="searchModel" attribute="destination_item_location_uuid"
                                                 :label="false"
                                                 :placeholder="$t('Destination Item Location')"/>
            </div>
            <div class="input-wrapper">
              <user-select-input-widget attribute="rep_user_uuid" @select="onRepUserSelect"
                                        :model="searchModel" :label="false" :options="{placeholder: $t('Rep. User')}"
                                        is-search/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="issue_date" type="daterangepicker" :label="false"
                            :placeholder="$t('Issue Date')"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="arrival_date" type="daterangepicker" :label="false"
                            :placeholder="$t('Arrival Date')"/>
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="$t('Service Provider')" :model="searchModel"
                            attribute="service_provider"/>
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="$t('Title')" :model="searchModel"
                            attribute="title"/>
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="$t('Receipt')" :model="searchModel" attribute="receipt_no"/>
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="$t('Item Number')" :model="searchModel" attribute="item_no"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";

  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import ItemLocationSelectInputWidget from "@/core/widgets/ItemLocationSelectInputWidget";
  import UserSelectInputWidget from "@/core/widgets/UserSelectInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('transferNotes');

  export default {
    name: "TransferNoteSearch",
    components: {UserSelectInputWidget, ItemLocationSelectInputWidget, InputWidget},
    computed: {
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
        types: state => state.types,
        statuses: state => state.statuses,
      }),
    },
    data() {
      return {}
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      onResetClick() {
        this.searchModel.arrival_date = null
        this.searchModel.arrival_date_date_range = {startDate: null, endDate: null};
        this.searchModel.issue_date = null
        this.searchModel.issue_date_date_range = {startDate: null, endDate: null};
        this.$nextTick(() => {
          this.resetTable();
        })
      },
      async onRepUserSelect(rep_user) {
        this.updateSearchModel({rep_user});
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
